const pagination = [
  { value: 5, display: "05" },
  { value: 10, display: "10" },
  { value: 25, display: "25" },
  { value: 50, display: "50" },
];
const avatar_image: string = "https://image.shutterstock.com/image-illustration/profile-picture-260nw-404137708.jpg";

const number_status = [
  { value: "AVAILABLE", display: "Available" },
  { value: "INUSE", display: "In Use" },
  { value: "RESERVED", display: "Reserved" },
  { value: "DISABLE", display: "Disable" },
];
const package_types = [
  { value: "MONTHLY", display: "Monthly Package" },
  { value: "EXTRA", display: "Extra Package" },
];

const chart: any = {
  series: [44, 55],
  options: {
    chart: {
      type: "donut",
      id: "chart",
    },
    colors: ["#0078C0", "#00DDEF"],
    // labels: ["Remain", "Used"],
    legend: { show: false, position: undefined },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            name: { show: true, fontFamily: "Rubik, sans-serif" },
            total: { show: true, fontFamily: "Rubik, sans-serif" },
            value: {
              show: true,
              fontSize: "28px",
              fontFamily: "Rubik,  sans-serif",
              fontWeight: 600,
              offsetY: 0,
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  },
};
const chart_extra: any = {
  series: [44, 55],
  options: {
    chart: {
      type: "donut",
      id: "chart",
    },
    colors: ["#ff9f43", "#ff6b6b"],
    // labels: ["Remain", "Used"],
    legend: { show: false, position: undefined },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            name: { show: true, fontFamily: "Rubik, sans-serif" },
            total: { show: true, fontFamily: "Rubik, sans-serif" },
            value: {
              show: true,
              fontSize: "28px",
              fontFamily: "Rubik,  sans-serif",
              fontWeight: 600,
              offsetY: 0,
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  },
};

const year = new Date().getFullYear().toString();
const month = (new Date().getMonth() + 1).toString();
const year_month = new Date().getFullYear().toString() + "_" + (new Date().getMonth() + 1).toString();

const resources = { avatar_image, number_status, pagination, package_types, chart, chart_extra, year, month, year_month };

export default resources;
